import React from "react";

import { ContribBucketAggregationElement } from "@js/invenio_search_ui/components";

export const BucketAggregationElement = (props) => {
  return <ContribBucketAggregationElement {...props} />;
};
